import React from 'react'

function EstadisticaMensual() {
  return (
    <div>
        <h1>Agosto 2023 </h1>
        promedio: 731677
        <h2>Realizo: 22682000</h2>
        <h2>Gatos: 20972100</h2>
        <br />
        <h1>Septiembre 2023:</h1>
        promedio: 743566
        <h2>Realizo:22307000</h2>
        <h2>Gastos:21507000</h2>
        <br/>
        <h1>Octubre 2023:</h1>
        promedio: 705516
        <h2>Realizo:21871000</h2>
        <h2>Gastos:22311400</h2>

        <br />
        <h1>Noviembre 2023:</h1>
        promedio: 708333
        <h2>Realizo:21250000</h2>
        <h2>Gastos:20987050</h2>

        <br />
        <h1>diciembre 2023:</h1>
        promedio: 776225
        <h2>Realizo:24063000</h2>
        <h2>Gastos:24323250</h2>
        <br />
        <h1>enero 2024:</h1>
        promedio: 781796
        <h2>Realizo:24235700</h2>
        <h2>Gastos:21604250</h2>

        <br />
        <h1>febrero 2024:</h1>
        promedio: 861965 
        <h2>Realizo:24997000</h2>
        <h2>Gastos:23426100</h2>

        <br />
        <h1>marzo 2024:</h1>
        promedio:912700
        <h2>Realizo: 28294000</h2>
        <h2>Gastos: 28130450</h2>
        acumulado anterior realizo 189644000
        gastos 183261600
        <br />
        <h1>abril 2024:</h1>
        promedio: 979000
        <h2>Realizo: 29371000</h2>
        <h2>Gastos: 28828250</h2>
        acumulado anterior realizo 219015000
        gastos 212089850
        <br />
        <h1>mayo 2024:</h1>
        promedio: 931000
        <h2>Realizo: 28866000</h2>
        <h2>Gastos: 31253850</h2>
        acumulado anterior realizo 247881000
        gastos 243253850
        <br />
        <h1>junio 2024:</h1>
        promedio: 938000
        <h2>Realizo:28155000</h2>
        <h2>Gastos:26985150</h2>
        acumulado anterior realizo 276036000
        gastos 270239000
        <br />
        <h1>julio 2024:</h1>
        promedio: 957000
        <h2>Realizo:29678000</h2>
        <h2>Gastos:25553650</h2>
        acumulado anterior realizo 305714000
        gastos 295792650
        <br />
        <h1>Agosto 2024:</h1>
        promedio: 911000
        <h2>Realizo: 28240400</h2>
        <h2>Gastos:28209900</h2>
        acumulado anterior realizo 333954400
        gastos 324002550
        <br />
        <h1>Septiembre 2024:</h1>
        promedio: 1237500
        <h2>Realizo: 37126000</h2>
        <h2>Gastos:35812250</h2>
        acumulado anterior realizo 371080400
        gastos 359814800

        <br />
        <h1>octubre 2024:</h1>
        promedio: 1216600
        <h2>Realizo: 37708000</h2>
        <h2>Gastos:31060750</h2>
        acumulado anterior realizo 408788400
        gastos 390875550
        
        <br />
        <h1>noviembre 2024:</h1>
        promedio: 1116000
        <h2>Realizo: 33486000</h2>
        <h2>Gastos:37652100</h2>
        acumulado anterior realizo 442274400
        gastos 428527650

        <br />
        <h1>Diciembre 2024:</h1>
        promedio: 1253100
        <h2>Realizo: 38847000</h2>
        <h2>Gastos:33178450</h2>
        acumulado anterior realizo 481121400
        gastos 461706100

        <br />
        <h1>Enero 2025:</h1>
        promedio: 1273000
        <h2>Realizo: 39471000</h2>
        <h2>Gastos:42514400</h2>
        acumulado anterior realizo 520592400
        gastos 504220500

        <br />
        <h1>Febrero 2025:</h1>
        promedio: 1428000
        <h2>Realizo: 39989000</h2>
        <h2>Gastos:39747350</h2>
        acumulado anterior realizo 560581400
        gastos 543967850

        <br />
        <h1>Marzo 2025:</h1>
        promedio: 1444000
        <h2>Realizo: 44771900 </h2>
        <h2>Gastos:39108250</h2>
        acumulado anterior realizo 605353300
        gastos 583076100
        <br />
        <h1>Abril 2025:</h1>
        promedio: 1393600
        <h2>Realizo: 41808000</h2>
        <h2>Gastos:41278650</h2>
        acumulado anterior realizo 647161300
        gastos 624354750
        <br />
             
         <br />
        <h1>mayo 2025:</h1>
        promedio: 1545400
        <h2>Realizo: 47908500</h2>
        <h2>Gastos:50327350</h2>
        acumulado anterior realizo 695069800
        gastos 674682100
        <br />
          <br />
        <h1>junio 2025:</h1>
        promedio: 1613000
        <h2>Realizo: 48395000</h2>
        <h2>Gastos:46009350</h2>
        acumulado anterior realizo 743464800
        gastos 720691450
        <br />
         <h1>julio 2025:</h1>
        promedio: 1810000
        <h2>Realizo: 56135000</h2>
        <h2>Gastos:54306400</h2>
        acumulado anterior realizo 799599800
        gastos 774997850
        <br />
           <h1>Agosto 2025:</h1>
        promedio: 1770800
        <h2>Realizo: 54896000</h2>
        <h2>Gastos:55015000</h2>
        acumulado anterior realizo 854495800
        gastos 830012850
        <br />
            <h1>septiembre 2025:</h1>
        promedio: 1894300
        <h2>Realizo: 56831000</h2>
        <h2>Gastos:55018550</h2>
        acumulado anterior realizo 911326800
        gastos 885031400
        <br />
          <h1>octubre 2025:</h1>
        promedio: 1766000
        <h2>Realizo: 54745400</h2>
        <h2>Gastos:57102250</h2>
        acumulado anterior realizo 966072200
        gastos 942133650
        <br />
          <h1>noviembre 2025:</h1>
        promedio: 1762000
        <h2>Realizo: 52868300 </h2>
        <h2>Gastos: 52829400</h2>
        acumulado anterior realizo 1018940500
        gastos 994963050
        <br />
        
             <h1>Diciembre 2025:</h1>
        promedio: 1704000
        <h2>Realizo: 52838000 </h2>
        <h2>Gastos: 49503450</h2>
        acumulado anterior realizo 1071778500
        gastos 1044466500
        <br />
              <h1>Enero 2026:</h1>
        promedio: 1848000
        <h2>Realizo: 55454000 </h2>
        <h2>Gastos:54316700 </h2>
        acumulado anterior realizo 1127232500
        gastos 1098783200
        <br />
           <h1>Febrero 2026:</h1>
        promedio: 1935000
        <h2>Realizo: 54180000 </h2>
        <h2>Gastos:52886150 </h2>
        acumulado anterior realizo 1181412500
        gastos 1151669350
        <br />
           <h1>Marzo 2026:</h1>
        promedio: 1876000
        <h2>Realizo: 58161000 </h2>
        <h2>Gastos:59519450 </h2>
        acumulado anterior realizo 1239573500
        gastos 1211188800
        <br />
        <h2>realizo año 2024 369003700</h2>
         <h2>realizo año 2025 590655000</h2>
    </div>
  )
}

export default EstadisticaMensual